import { getChecklistStorageKey } from "../constants/buyerChecklistConstants";

function isStorageAvailable() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return false;
    const probe = "__automap_checklist_probe__";
    window.localStorage.setItem(probe, "1");
    window.localStorage.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

export function loadChecklistState(listingId = null) {
  if (!isStorageAvailable()) return { checked: {}, updatedAt: null };
  try {
    const raw = window.localStorage.getItem(getChecklistStorageKey(listingId));
    if (!raw) return { checked: {}, updatedAt: null };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return { checked: {}, updatedAt: null };
    return {
      checked: parsed.checked && typeof parsed.checked === "object" ? parsed.checked : {},
      updatedAt: parsed.updatedAt || null,
    };
  } catch {
    return { checked: {}, updatedAt: null };
  }
}

export function saveChecklistState(listingId, checked) {
  if (!isStorageAvailable()) return false;
  try {
    const payload = {
      checked: checked || {},
      updatedAt: new Date().toISOString(),
    };
    window.localStorage.setItem(getChecklistStorageKey(listingId), JSON.stringify(payload));
    return true;
  } catch {
    return false;
  }
}

export function clearChecklistState(listingId = null) {
  if (!isStorageAvailable()) return false;
  try {
    window.localStorage.removeItem(getChecklistStorageKey(listingId));
    return true;
  } catch {
    return false;
  }
}

export function listSavedChecklistKeys() {
  if (!isStorageAvailable()) return [];
  const keys = [];
  for (let i = 0; i < window.localStorage.length; i += 1) {
    const key = window.localStorage.key(i);
    if (key?.startsWith("automap_checklist_")) keys.push(key);
  }
  return keys;
}

export function calculateChecklistProgress(itemIds, checkedMap = {}) {
  const ids = itemIds || [];
  if (!ids.length) return { checked: 0, total: 0, percent: 0 };
  const checked = ids.filter((id) => Boolean(checkedMap[id])).length;
  const total = ids.length;
  const percent = Math.round((checked / total) * 100);
  return { checked, total, percent };
}

export function isChecklistComplete(itemIds, checkedMap = {}) {
  const progress = calculateChecklistProgress(itemIds, checkedMap);
  return progress.total > 0 && progress.checked === progress.total;
}
